import Groups from 'lib/constants/Groups';

const isEditorOnly = groups =>
  groups.length === 0 || (groups.length === 1 && groups[0] === Groups.EDITORS);

export default isEditorOnly;
